import { Accordion, Card } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined } from '@mui/icons-material';

const ItemsList = (props) => {
    const [itmsLst, setItmsLst] = useState(props.itmsLst || []);
    const [cheksSelctions, setCheksSelctions] = useState(props.itmsLst.items?.map(sld => sld._id) || []);
    const [slideItem, setSlideItem] = useState(props.slideItem);

    useEffect(() => {
        setItmsLst(props.itmsLst);
    }, [props.itmsLst]);

    useEffect(() => {
        setSlideItem(props.slideItem);
        let lstOfselects = [...cheksSelctions];
        slideItem.items.forEach(divElement => {
            let exists = lstOfselects.some(item => item.Id === divElement.Id);
            if (!exists) {
                let temposel = {
                    parentId: divElement.parentId,
                    Id: divElement.Id,
                };
                lstOfselects.push(temposel);
            }
        });
        setCheksSelctions(lstOfselects);
    }, [props.slideItem]);

    const handleParentCheck = (itm, checked) => {
        const updatedSelections = checked
            ? [...cheksSelctions, ...itm.items.map(inItm => ({ parentId: itm.id, Id: inItm._id }))]
            : cheksSelctions.filter(it => !itm.items.some(inItm => inItm._id === it.Id));

        setCheksSelctions(updatedSelections);

        props.changeSlideItems(updatedSelections)
    };

    const handleChildCheck = (inItm, parentId, checked) => {
        const updatedSelections = checked
            ? [...cheksSelctions, { parentId, Id: inItm._id }]
            : cheksSelctions.filter(it => it.Id !== inItm._id);

        setCheksSelctions(updatedSelections);

        props.changeSlideItems(updatedSelections)

    };

    const isParentChecked = (itm) => {
        return itm.items.every(inItm => cheksSelctions.some(it => it.Id === inItm._id));
    };

    const isParentIndeterminate = (itm) => {
        const selectedChildren = itm.items.filter(inItm => cheksSelctions.some(it => it.Id === inItm._id)).length;
        return selectedChildren > 0 && selectedChildren < itm.items.length;
    };

    return (
        <div className={`grayFrame`}>
            <label>הפריטים לתצוגה</label>
            <div>
                {itmsLst.map((itm, indx) => (
                    <Card key={indx}>
                        <Accordion.Collapse className="collapseparent" eventKey={`${indx}_evnt`}>
                            <Card.Body style={{ color: 'black' }}>
                                <Accordion defaultActiveKey="0" className="has-gap ms-accordion-chevron">
                                    {itm.items.map((inItm, inIndx) => (
                                        <div key={inIndx} className={"spaceMargeRightbig"}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={cheksSelctions.some(it => it.Id === inItm._id)}
                                                        icon={<CheckBoxOutlineBlankOutlined sx={{ color: 'var(--mainColor)' }} />}
                                                        checkedIcon={<CheckBoxOutlined sx={{ color: 'var(--mainColor)' }} />}
                                                        onChange={(e) => handleChildCheck(inItm, itm.id, e.target.checked)}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        className={"blackCheck"}
                                                    />
                                                }
                                                label={`${inItm.prodName}`}
                                            />
                                        </div>
                                    ))}
                                </Accordion>
                            </Card.Body>
                        </Accordion.Collapse>
                        <Accordion.Toggle as={Card.Header} eventKey={`${indx}_evnt`}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={itm.items.length > 0 ? isParentChecked(itm) : false}
                                        indeterminate={isParentIndeterminate(itm)}
                                        icon={<CheckBoxOutlineBlankOutlined sx={{ color: 'white' }} />}
                                        checkedIcon={<CheckBoxOutlined sx={{ color: 'white' }} />}
                                        onChange={(e) => handleParentCheck(itm, e.target.checked)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        className={"blackCheck"}
                                    />
                                }
                                label={`${itm.DivName}`}
                            />
                        </Accordion.Toggle>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default ItemsList;
